import { render, staticRenderFns } from "./BuildingHandoverTemplates.vue?vue&type=template&id=0bf45d68&"
import script from "./BuildingHandoverTemplates.vue?vue&type=script&lang=js&"
export * from "./BuildingHandoverTemplates.vue?vue&type=script&lang=js&"
import style0 from "./BuildingHandoverTemplates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf45d68')) {
      api.createRecord('0bf45d68', component.options)
    } else {
      api.reload('0bf45d68', component.options)
    }
    module.hot.accept("./BuildingHandoverTemplates.vue?vue&type=template&id=0bf45d68&", function () {
      api.rerender('0bf45d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/BuildingHandoverTemplates.vue"
export default component.exports